/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Lifts_PickerInputs */

const en_us2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise`)
};

const pt_br2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício`)
};

const es_419_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio`)
};

const pt_pt2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício`)
};

const fr_fr2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice`)
};

const de_de2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung`)
};

const it_it2_progress_lifts_picker = /** @type {(inputs: Progress_Lifts_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise" |
*
* @param {Progress_Lifts_PickerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_picker = /** @type {((inputs?: Progress_Lifts_PickerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_PickerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_picker(inputs)
	if (locale === "es-419") return es_419_progress_lifts_picker(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_picker(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_picker(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_picker(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_picker(inputs)
	return en_us2_progress_lifts_picker(inputs)
});
export { progress_lifts_picker as "progress.lifts_picker" }